import { useState, useEffect } from 'react';

function useApi(url, options = null) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [statusCode, setStatusCode] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(url, options);
        const json = await response.json();
        setData(json);
        setStatusCode(response.status);
        if (!response.ok) {
          setError(json);
        } else {
          setError(null);
        }
      } catch (error) {
        setError(error);
        setData(null);
        setStatusCode(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [url, options]);

  return { data, error, isLoading, statusCode };
}

export default useApi;
